import { logError } from '../../utilities/logging';
import { storefront } from '../client';
import { fetchMetaobjectsByIds } from './fetchMetaobjectsById';

const getVendorQuery = `
query getVariant($id: ID!, $metafieldNamespace: String!, $metafieldKey: String!) {
  node(id: $id) {
    ... on ProductVariant {
      metafield(namespace: $metafieldNamespace, key: $metafieldKey) {
        value
      }
    }
  }
}`;

export const fetchVendor = async ({ variantId, country }) => {
  const { data, errors } = await storefront.request(getVendorQuery, {
    variables: { id: variantId, metafieldNamespace: '$app:shipping', metafieldKey: 'vendor' }
  });

  const vendorRes = await fetchMetaobjectsByIds({country})({ids: [data?.node?.metafield?.value], metaObjectType: 'Metaobject'});
  const vendorHandle = vendorRes.at(0).internalName;

  if (errors) {
    logError({
      label: 'fetchVendor',
      error: new Error('GraphQL errors occurred'),
      message: 'Error gathering vendor data for variant ID',
      extraData: { variantId, errors }
    });
    throw new Error(`Error gathering vendor data for variant ID: ${variantId}`);
  }

  if (!vendorHandle) {
    logError({
      label: 'fetchVendor',
      error: new Error('No vendor data found for variant ID'),
      message: 'No vendor data found for variant ID',
      extraData: { variantId }
    });
  }

  return vendorHandle;
};
